import React from 'react'

import TwoFactorAuthentication from './TwoFactorAuthentication'
import ChangePassword from './ChangePassword'
import MyHistory from './MyHistory'
import LinkedDevices from './LinkedDevices'
import DeleteAccount from './DeleteAccount'

const AccountSecurity = () => {
  return (
    <div className="mt-[20px] bg-[#FEEBDD] rounded-[10px] p-[32px]">
      <h4 className="text-base font-bold text-primary-100">Account Security</h4>

      <TwoFactorAuthentication />

      <ChangePassword />

      <MyHistory />

      <LinkedDevices />

      <DeleteAccount />
    </div>
  )
}

export default AccountSecurity
